import { Actions, createNamespace } from "../../../flux/Actions";

const ns = createNamespace('FLAG');
export const names = {
    SET: ns('SET'),
    RESET: ns('RESET'),
};

// Flux actions to manipulate FlagStore's state
export class FlagActions extends Actions
{
    set = (dispatchToken: string) => this.dispatch(names.SET, null, dispatchToken);
    reset = (dispatchToken: string) => this.dispatch(names.RESET, null, dispatchToken);
}


// WEBPACK FOOTER //
// ./src/app/flux/Flag/FlagActions.ts